import { isSameDay } from 'date-fns'
import { isEqual } from 'lodash'
import { formatDateAndHoursMinutes, formatHoursMinutes, toDate } from 'util/date/formatDate'

import { LISTA_REGULACAO_DEFAULT_FILTERS, ListaRegulacaoTableFilterModel } from './model-regulacao'

export function formatDateHistoricoRegulacao(date: LocalDate, dateToCompare: Date): string {
  if (isSameDay(toDate(date), dateToCompare)) {
    return `hoje às ${formatHoursMinutes(date)}`
  } else {
    return `em ${formatDateAndHoursMinutes(date)}`
  }
}

export function isFilterTableEqualDefault(currentFilter: ListaRegulacaoTableFilterModel) {
  return isEqual(
    {
      ordem: currentFilter.ordem,
      nomeCnsCpf: currentFilter.nomeCnsCpf,
      isSomenteMeusAtendimentos: currentFilter.isSomenteMeusAtendimentos,
      isSomenteNaoLidos: currentFilter.isSomenteNaoLidos,
      periodo: currentFilter.periodo,
      solicitantes: currentFilter.solicitantes,
    },
    {
      ordem: LISTA_REGULACAO_DEFAULT_FILTERS.tableFilter.ordem,
      nomeCnsCpf: LISTA_REGULACAO_DEFAULT_FILTERS.tableFilter.nomeCnsCpf,
      isSomenteMeusAtendimentos: LISTA_REGULACAO_DEFAULT_FILTERS.tableFilter.isSomenteMeusAtendimentos,
      isSomenteNaoLidos: LISTA_REGULACAO_DEFAULT_FILTERS.tableFilter.isSomenteNaoLidos,
      periodo: LISTA_REGULACAO_DEFAULT_FILTERS.tableFilter.periodo,
      solicitantes: LISTA_REGULACAO_DEFAULT_FILTERS.tableFilter.solicitantes,
    }
  )
}
